var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 49,
    viewBox: "0 0 70 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 69,
    height: 47,
    rx: 5.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_715_50251)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 25,
    r: 17,
    fill: "#EDF0F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9495 13.666L37.7449 16.5288L30.7058 23.5679L27.9104 20.7725L34.9495 13.666Z",
    fill: "#F0B90B",
    stroke: "#F0B90B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1931 17.9102L41.9886 20.7729L30.7058 32.0557L27.9104 29.2603L39.1931 17.9102Z",
    fill: "#F0B90B",
    stroke: "#F0B90B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4622 22.1543L29.2576 25.0171L26.4622 27.8125L23.6667 25.0171L26.4622 22.1543Z",
    fill: "#F0B90B",
    stroke: "#F0B90B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4368 22.1543L46.2322 25.0171L34.9495 36.2998L32.1541 33.5044L43.4368 22.1543Z",
    fill: "#F0B90B",
    stroke: "#F0B90B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_715_50251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(18 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusd);
export default __webpack_public_path__ + "static/media/busd.2eaafab0c1f1827365fa383428ab989a.svg";
export { ForwardRef as ReactComponent };